import { Button, Dialog, DialogActions, DialogTitle } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import LoadingOverlay from 'react-loading-overlay';

const styles = {
    paper: {
        minWidth: 360,
    },
    title: {
        padding: '24px 32px 16px',
        textAlign: 'center',
    },
    actions: {
        justifyContent: 'center',
        padding: '8px 24px 24px',
    },
    button: {
        minWidth: 96,
        margin: '0 8px',
    },
};

const modal = ({
    classes,
    isModalOpen,
    isSpinnerActive,
    handleAnswer,
    modalMessage,
    confirmButtonColor = 'primary',
}) => {
    const handleAnswerNo = () => {
        handleAnswer(false);
    };

    const handleAnswerYes = () => {
        handleAnswer(true);
    };

    return (
        <div>
            <Dialog open={isModalOpen} onClose={handleAnswerNo} classes={{ paper: classes.paper }}>
                <LoadingOverlay
                    active={isSpinnerActive}
                    spinner
                    text="Proszę czekać..."
                    styles={{
                        content: base => ({
                            ...base,
                            marginLeft: '50%',
                            margin: '4%',
                            transform: 'translateX(-50%)',
                        }),
                    }}>
                    <DialogTitle id="alert-dialog-title" className={classes.title}>
                        {modalMessage}
                    </DialogTitle>
                    <DialogActions className={classes.actions}>
                        <Button
                            onClick={handleAnswerNo}
                            color="primary"
                            variant="outlined"
                            className={classes.button}>
                            Nie
                        </Button>
                        <Button
                            onClick={handleAnswerYes}
                            color={confirmButtonColor}
                            variant="contained"
                            className={classes.button}
                            autoFocus>
                            Tak
                        </Button>
                    </DialogActions>
                </LoadingOverlay>
            </Dialog>
        </div>
    );
};

export default withStyles(styles)(modal);
